import {
  PAGE_QUESTIONS,
  PageQuestionsRequest,
  PageQuestionsResponse,
} from "@project/shared-types";
import apiFetchPost from '../../../api/apiClient';

export const GetQuestionsAPI = async (dataRequest: PageQuestionsRequest) => {
  const response = await apiFetchPost<
    PageQuestionsRequest,
    PageQuestionsResponse
  >(PAGE_QUESTIONS, dataRequest);
  return response;
};
